import React from "react";

import { getReorderActions, type ReorderDirection } from "./reorderUtils";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../intelligence-briefing-library/components/ui/tooltip";

interface ReorderControlsProps {
  index: number;
  length: number;
  disabled?: boolean;
  onMove: (direction: ReorderDirection) => void;
}

const tipClass =
  "z-[9999] border border-gray-200 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-800 shadow-[0_4px_12px_rgba(0,0,0,0.1)]";

/** Inline Move up / down / top / bottom buttons for list Edit Order. */
const ReorderControls: React.FC<ReorderControlsProps> = ({
  index,
  length,
  disabled = false,
  onMove,
}) => {
  const actions = getReorderActions({ index, length, disabled, onMove });

  return (
    <TooltipProvider delayDuration={0} skipDelayDuration={0}>
      <div className="reorder-controls" role="group" aria-label="Reorder">
        {actions.map(action => {
          const Icon = action.icon;
          return (
            <Tooltip key={action.id} disableHoverableContent>
              <TooltipTrigger asChild>
                <button
                  type="button"
                  className="reorder-controls__btn"
                  aria-label={action.label}
                  disabled={action.disabled}
                  onClick={event => {
                    event.stopPropagation();
                    if (action.disabled) return;
                    action.onClick();
                  }}
                >
                  {Icon && <Icon size={15} aria-hidden />}
                </button>
              </TooltipTrigger>
              <TooltipContent side="top" sideOffset={6} className={tipClass}>
                {action.label}
              </TooltipContent>
            </Tooltip>
          );
        })}
      </div>
    </TooltipProvider>
  );
};

export default ReorderControls;
